import React, { useState } from "react";
import "./Login.css";
import { FaGoogle } from "react-icons/fa";
import { BsMicrosoftTeams } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import tickets from "../../assets/tickets.png";
import qr from "../../assets/qrcode.png";

function App() {
  const [isSignUp, setIsSignUp] = useState(false);
  const [User, setUser] = useState({
    username: "",
    password: "",
    newusername: "",
    newpassword: "",
    newconfirmpassword: "",
    email: "",
    phno: "",
  });
  const [Credienticals, setCredienticals] = useState({});

  const navigate = useNavigate();

  const handleSignUpClick = () => {
    setIsSignUp(true); // Switch to SignUp form
  };

  const handleSignInClick = () => {
    setIsSignUp(false); // Switch to SignIn form
  };

  const validateLogin = async (event) => {
    event.preventDefault();
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/login.php`;
    const formData = new FormData();
    try {
      const formData = new FormData();
      formData.append("user_name", User?.username);
      formData.append("password", User?.password);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      setCredienticals(data);
      if (data.message === "Login successful") {
        setUser({
          username: "",
          password: "",
          newusername: "",
          newpassword: "",
          newconfirmpassword: "",
        });
        const userDetails = {
          username: data.user_name,
          role: data.role,
          email: data.email,
          userid: data.id,
          phone: data.phone_no,
        };
        localStorage.setItem("userdetails", JSON.stringify(userDetails));
        if (data.role === "support") {
          navigate("/SU");
        } else {
          navigate("/CM");
        }
      } else {
        alert("User Doesn`t exist, Please Signup");
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  const validatesign = async (event) => {
    event.preventDefault();
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/signup.php`;
    const formData = new FormData();
    try {
      if (User.newpassword === User.newconfirmpassword) {
        const formData = new FormData();
        formData.append("user_name", User?.newusername);
        formData.append("password", User?.newpassword);
        formData.append("email", User?.email);
        formData.append("phone_no", User?.phno);

        const response = await fetch(apiUrl, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        setCredienticals(data);
        if (data.message === "Login successful") {
          setUser({
            username: "",
            password: "",
            newusername: "",
            newpassword: "",
            newconfirmpassword: "",
            email: "",
            phno: "",
          });
          alert(data.message);
          // console.log(data);
        } else {
          alert(data.message);
        }
      } else {
        alert("Password and Confirm Password should be same");
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  const handleforgotpass = () => {
    navigate("/Forgot");
  };

  return (
    <div className="wrapper">
      <div>
        <img className="bg" src={tickets} alt="logo" />
      </div>
      <div className="wrapper1">
        <div className="ticketrise-form-section">
          <h2>SCAN ME</h2>
          <img src={qr} alt="Scanfdd QR Code" />
          <div className="custom-tooltip-wrapper">
            <a
              href="https://ltaf.myhrsoft.com/Ticketrise"
              target="_blank"
              className="custom-tooltip-link"
            >
              Link to Raise a Ticket
              <span className="tooltip-text">
                https://ltaf.myhrsoft.com/Ticketrise
              </span>
            </a>
          </div>

          <h2>One Tap. One Ticket. One Solution.</h2>
        </div>

        <div className="container0">
          {isSignUp ? (
            <div className="signin">
              <div className="heading">Sign Up</div>
              <form onSubmit={validatesign} className="form">
                <input
                  value={User?.newusername}
                  onChange={(e) =>
                    setUser((prev) => ({
                      ...prev,
                      newusername: e.target.value,
                    }))
                  }
                  required
                  className="input"
                  placeholder="User Name"
                  type="text"
                />
                <input
                  value={User?.newpassword}
                  onChange={(e) =>
                    setUser((prev) => ({
                      ...prev,
                      newpassword: e.target.value,
                    }))
                  }
                  required
                  className="input"
                  placeholder="Password"
                  type="password"
                />
                <input
                  value={User?.newconfirmpassword}
                  onChange={(e) =>
                    setUser((prev) => ({
                      ...prev,
                      newconfirmpassword: e.target.value,
                    }))
                  }
                  required
                  className="input"
                  placeholder="Confirm Password"
                  type="password"
                />
                <input
                  value={User?.email}
                  onChange={(e) =>
                    setUser((prev) => ({ ...prev, email: e.target.value }))
                  }
                  required
                  className="input"
                  placeholder="E-Mail"
                  type="email"
                />
                <input
                  value={User?.phno}
                  onChange={(e) =>
                    setUser((prev) => ({ ...prev, phno: e.target.value }))
                  }
                  required
                  className="input"
                  placeholder="Mobile Number"
                  type="tel"
                  pattern="[0-9]{10  }"
                />
                <button className="login-button">Signup</button>
                <div className="signup">
                  <p>
                    You already have an account?{" "}
                    <span onClick={handleSignInClick}>
                      <a href="#">Login</a>
                    </span>
                  </p>
                </div>
              </form>
              <div className="social-account">
                <div className="google">
                  <a href="https://accounts.google.com/" target="blank">
                    <FaGoogle />
                  </a>
                </div>
                <div className="msoft">
                  <a
                    href="https://login.microsoftonline.com/common/oauth2"
                    target="blank"
                  >
                    <BsMicrosoftTeams />
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <div className="login">
              <div className="heading">Login</div>
              <form onSubmit={validateLogin} className="form">
                <input
                  value={User?.username}
                  onChange={(e) =>
                    setUser((prev) => ({ ...prev, username: e.target.value }))
                  }
                  required
                  className="input"
                  placeholder="User Name"
                  type="text"
                />
                <input
                  value={User?.password}
                  onChange={(e) =>
                    setUser((prev) => ({ ...prev, password: e.target.value }))
                  }
                  required
                  className="input"
                  placeholder="Password"
                  type="password"
                />
                <span className="forgot-password" onClick={handleforgotpass}>
                  <a>Forgot Password?</a>
                </span>
                <button className="login-button">Login</button>
                <div className="signup">
                  {/* <p>Don't have an account? <span onClick={handleSignUpClick}><a href="#">Sign Up</a></span></p> */}
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
